<template>
  <div v-title="$route.meta.title"
       class="training-instruction-table">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试培训管理</el-breadcrumb-item>
        <el-breadcrumb-item>培训管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="training-instruction-table__card training-instruction-table__card--search">
      <div class="training-instruction-table__card-header"
           @click="searchExpanded = !searchExpanded">
        <span>搜索</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>

      <el-form v-show="searchExpanded"
               :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="left"
               size="small"
               class="training-instruction-table__search-form"
               @submit.native.prevent="onSearch()">
        <div class="training-instruction-table__search-grid">
          <el-form-item label="培训名称"
                        prop="title">
            <el-input v-model="search.title"
                      placeholder="请输入培训名称"
                      clearable />
          </el-form-item>
          <el-form-item label="培训类型"
                        prop="instruction_type">
            <el-select v-model="search.instruction_type"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.typeMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否通用"
                        prop="is_common">
            <el-select v-model="search.is_common"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.isCommonMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="所属知识库"
                        prop="training_knowledge_id">
            <remote-select class="width-max"
                           clearable
                           keyword-key="name"
                           label-key="name"
                           placeholder="请输入知识库名称搜索"
                           v-model="search.training_knowledge_id"
                           :query-request="queryTrainingKnowledge"
                           :find-request="getTrainingKnowledge" />
          </el-form-item>
          <el-form-item label="所属客户"
                        prop="customerid">
            <remote-select class="width-max"
                           clearable
                           placeholder="请输入客户名称/编号搜索"
                           v-model="search.customerid"
                           :query-request="getBasicCustomerTable"
                           :find-request="getCustomerDetail" />
          </el-form-item>
          <el-form-item label="状态"
                        prop="instruction_status">
            <el-select v-model="search.instruction_status"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.statusMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="培训分组"
                        prop="instruction_group_id">
            <el-select v-model="search.instruction_group_id"
                       class="width-max"
                       filterable
                       clearable
                       placeholder="请选择">
              <el-option v-for="item in instructionGroups"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="创建人"
                        prop="creator_id">
            <remote-select class="width-max"
                           clearable
                           placeholder="请输入管理员"
                           keyword-key="name"
                           v-model="search.creator_id"
                           :query-request="getBasicPlatformUsersIndex"
                           :find-request="getPlatformUsersDetail" />
          </el-form-item>
          <el-form-item label="所属用户类型"
                        prop="target_usertype">
            <el-select v-model="search.target_usertype"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.targetUserMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable />
          </el-form-item>
        </div>
        <div class="training-instruction-table__search-actions">
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置</el-button>
        </div>
      </el-form>
    </div>

    <div class="training-instruction-table__card">
      <div class="training-instruction-table__card-header"
           @click="listExpanded = !listExpanded">
        <span>列表</span>
        <div class="training-instruction-table__card-header-actions">
          <el-button type="text"
                     icon="el-icon-setting"
                     class="training-instruction-table__header-action"
                     title="列配置"
                     @click.stop="openTableColumnConfigDialog" />
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="training-instruction-table__header-action"
                     @click.stop="onRefresh()" />
          <span class="training-instruction-table__header-action">
            <i :class="listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </span>
        </div>
      </div>

      <div v-show="listExpanded"
           class="training-instruction-table__list-body">
        <!--
          原型列表区有「零工 / 审核实习生」Tab 切换，并在创建区附带用户类型选择。
          管理端改为：用户类型仅作为上方搜索项 target_usertype 筛选，创建入口保持跳转表单页并在表单内选择用户类型。
        -->
        <div class="training-instruction-table__toolbar">
          <router-link :to="'/training/instruction/create'">
            <el-button type="primary"
                       size="small">创建培训</el-button>
          </router-link>
        </div>

        <div class="training-instruction-table__table-wrap">
          <el-table :key="tableColumnRenderKey"
                    :data="table"
                    class="training-instruction-table__table"
                    style="width: 100%">
            <el-table-column v-for="field in activeTableFields"
                             :key="field.key"
                             v-bind="getFieldColumnBind(field)">
              <template slot="header">
                <span>{{ field.label }}</span>
                <el-tooltip v-if="field.tooltip"
                            :content="field.tooltip">
                  <i class="el-icon-warning training-instruction-table__header-tip" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-image v-if="field.slot === 'cover'"
                          class="cover-image"
                          fit="cover"
                          :src="getFirstCoverUrl(scope.row.cover_imgs)"
                          :preview-src-list="getCoverPreviewList(scope.row.cover_imgs)">
                  <div slot="error"
                       class="cover-image__placeholder">-</div>
                </el-image>
                <span v-else-if="field.slot === 'tag'"
                      :class="['training-instruction-table__tag', field.tagClass(scope.row)]">
                  {{ field.formatter(scope.row) }}
                </span>
                <span v-else-if="field.slot === 'knowledge'"
                      class="knowledge-name">
                  <i class="el-icon-folder knowledge-name__icon" />
                  <span>{{ scope.row.training_knowledge_name || '-' }}</span>
                </span>
                <router-link v-else-if="field.slot === 'link'"
                             :to="field.linkTo(scope.row)"
                             :class="['count-link', { 'count-link--muted': field.linkMuted(scope.row) }]">
                  <span class="count-link__content">
                    <training-instruction-count-icon v-if="field.linkIcon"
                                                     :name="field.linkIcon"
                                                     class="count-link__icon" />
                    {{ field.linkText(scope.row) }}
                  </span>
                </router-link>
                <template v-else>
                  {{ field.formatter ? field.formatter(scope.row) : scope.row[field.prop] }}
                </template>
              </template>
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             width="280"
                             align="left">
              <template slot-scope="scope">
                <div class="training-instruction-table__actions">
                  <span class="training-instruction-table__action is-edit"
                        @click="$router.push(`/training/instruction/update/${scope.row.id}`)">修改</span>
                  <button v-if="canEnable(scope.row)"
                          type="button"
                          class="training-instruction-table__action is-enable"
                          @click="onEnable(scope.row)">上架</button>
                  <button v-if="canDisable(scope.row)"
                          type="button"
                          class="training-instruction-table__action is-disable"
                          @click="onDisable(scope.row)">下架</button>
                  <button v-if="canDelete(scope.row)"
                          type="button"
                          class="training-instruction-table__action is-delete"
                          @click="onDelete(scope.row)">删除</button>
                  <span class="training-instruction-table__action is-bind"
                        @click="goBindHistory(scope.row)">绑定历史</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total" />
        </div>
      </div>
    </div>

    <table-column-config-dialog :visible.sync="tableColumnConfigDialogVisible"
                                :applied-columns="tableColumnAppliedConfig"
                                :definitions="fields"
                                @save="onTableColumnConfigSave" />
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import dateTimePicker from '@core/mixins/dateTimePicker'
import tableColumnConfig from '@core/mixins/table-column-config'
import { opts, consts, TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY } from '@views/training/training-instruction.constants'
import { createTrainingInstructionTableFields } from '@views/training/training-instruction-table.fields'
import trainingMixins from '@views/training/training.mixins'
import TrainingInstructionCountIcon from '@views/training/components/TrainingInstructionCountIcon.vue'

const FIELD_COLUMN_BIND_KEYS = ['prop', 'label', 'width', 'minWidth', 'showOverflowTooltip', 'fixed', 'align']

export default {
  components: {
    TrainingInstructionCountIcon,
  },
  mixins: [table, dateTimePicker, trainingMixins, tableColumnConfig],
  data () {
    return {
      searchExpanded: true,
      listExpanded: true,
      opts,
      search: {
        title: '',
        instruction_type: null,
        target_usertype: null,
        is_common: null,
        training_knowledge_id: null,
        customerid: null,
        instruction_status: null,
        instruction_group_id: null,
        creator_id: null,
        created_at: [],
      },
      searchFieldType: {
        instruction_type: Number,
        target_usertype: Number,
        is_common: Number,
        training_knowledge_id: Number,
        customerid: Number,
        instruction_status: Number,
        instruction_group_id: Number,
        creator_id: Number,
        created_at: Array,
      },
      fields: createTrainingInstructionTableFields(this),
    }
  },
  computed: {
    showWorkerColumns () {
      return Number(this.search.target_usertype) !== consts.TARGETUSER_TYPE_INTERN
    },
    activeTableFields () {
      const fieldMap = _.keyBy(this.fields, 'key')
      return this.activeTableColumns
        .map(column => fieldMap[column.key])
        .filter(Boolean)
    },
  },
  created () {
    this.loadGroups()
  },
  methods: {
    getTableColumnStorageKey () {
      return TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY
    },
    getFieldColumnBind (field) {
      return _.pick(field, FIELD_COLUMN_BIND_KEYS)
    },
    ...request.map([
      'getBasicCustomerTable',
      'getCustomerDetail',
      'getBasicPlatformUsersIndex',
      'getPlatformUsersDetail',
      'queryTrainingKnowledge',
      'getTrainingKnowledge',
    ]),
    getTableData (params) {
      return request.page('queryTrainingInstruction', params)
    },
    formatType (row) {
      return filter.getLabelText(this.opts.typeMaps, row.instruction_type)
    },
    formatIsCommon (row) {
      return filter.getLabelText(this.opts.isCommonMaps, row.is_common)
    },
    formatAppDisplay (row) {
      return filter.getLabelText(this.opts.boolMaps, row.display_in_app_learning_center)
    },
    formatStatus (row) {
      return filter.getLabelText(this.opts.statusMaps, row.instruction_status)
    },
    getTypeTagClass (type) {
      const map = {
        [consts.TYPE_ONLY_LEARNING]: 'is-learning',
        [consts.TYPE_ONLY_EXAM]: 'is-exam',
        [consts.TYPE_LEARNING_AND_EXAM]: 'is-both',
      }
      return map[Number(type)] || 'is-default'
    },
    getStatusTagClass (status) {
      const value = Number(status)
      if (value === consts.STATUS_ONLINE) {
        return 'is-online'
      }
      if (value === consts.STATUS_OFFLINE) {
        return 'is-offline'
      }
      return 'is-new'
    },
    getIsCommonTagClass (isCommon) {
      return Number(isCommon) === consts.IS_COMMON_SHARED ? 'is-common-shared' : 'is-common-dedicated'
    },
    canEnable (row) {
      return [consts.STATUS_NEW, consts.STATUS_OFFLINE].includes(Number(row.instruction_status))
    },
    canDisable (row) {
      return Number(row.instruction_status) === consts.STATUS_ONLINE
    },
    canDelete (row) {
      return Number(row.instruction_status) === consts.STATUS_NEW
    },
    getFirstCoverUrl (coverImgs) {
      if (!Array.isArray(coverImgs) || !coverImgs.length) {
        return ''
      }
      const first = coverImgs[0]
      return first && first.url ? first.url : ''
    },
    getCoverPreviewList (coverImgs) {
      if (!Array.isArray(coverImgs) || !coverImgs.length) {
        return []
      }
      return coverImgs.map(item => item && item.url).filter(Boolean)
    },
    getRecordLink (row) {
      return {
        path: `/training/instruction/records/${row.id}`,
        query: { title: row.title },
      }
    },
    getExamRecordLink (row) {
      return {
        path: `/training/instruction/exam-records/${row.id}`,
        query: { title: row.title },
      }
    },
    goBindHistory (row) {
      this.$router.push({
        path: `/training/instruction/bind-history/${row.id}`,
        query: { title: row.title },
      })
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    onEnable (row) {
      this.$confirm(`确认上架培训「${row.title}」吗？上架后将在 App 学习中心展示。`, '提示', { type: 'warning' }).then(() => {
        request.common('enableTrainingInstruction', row.id).then(() => {
          this.$message.success('上架成功')
          this.onRefresh()
        })
      }).catch(() => {})
    },
    onDisable (row) {
      this.$confirm(`确认下架培训「${row.title}」吗？下架后 App 将不再展示，已开始的用户不受影响。`, '提示', { type: 'warning' }).then(() => {
        request.common('disableTrainingInstruction', row.id).then(() => {
          this.$message.success('下架成功')
          this.onRefresh()
        })
      }).catch(() => {})
    },
    onDelete (row) {
      this.$confirm(`确认删除培训「${row.title}」吗？删除后无法恢复。`, '提示', { type: 'warning' }).then(() => {
        request.common('deleteTrainingInstruction', row.id).then(() => {
          this.$message.success('删除成功')
          this.onRefresh()
        })
      }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.training-instruction-table {
  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    & + & {
      margin-top: 16px;
    }
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;

    i {
      color: #909399;
    }
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .training-instruction-table__header-action.el-button {
      min-width: 24px;
      padding: 0;
      margin: 0;
    }
  }

  &__header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    color: #909399;
    flex-shrink: 0;
    line-height: 1;

    i {
      font-size: 14px;
    }
  }

  &__search-form {
    padding: 16px 24px 20px;
  }

  &__search-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__search-actions {
    margin-top: 4px;
    padding-top: 4px;
  }

  &__list-body {
    padding: 0 16px 16px;
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 16px 8px;
    border-bottom: 1px solid #ebeef5;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 0;
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }
    }
  }

  &__header-tip {
    margin-left: 4px;
    color: #c0c4cc;
    cursor: help;
  }

  &__tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;

    &.is-learning {
      background: #dbeafe;
      color: #1d4ed8;
    }

    &.is-exam {
      background: #ede9fe;
      color: #6d28d9;
    }

    &.is-both {
      background: #dcfce7;
      color: #15803d;
    }

    &.is-default {
      background: #f3f4f6;
      color: #4b5563;
    }

    &.is-online {
      background: #dcfce7;
      color: #15803d;
    }

    &.is-offline {
      background: #f3f4f6;
      color: #6b7280;
    }

    &.is-new {
      background: #dbeafe;
      color: #1d4ed8;
    }

    &.is-common-shared {
      background: #dcfce7;
      color: #15803d;
    }

    &.is-common-dedicated {
      background: #f3f4f6;
      color: #4b5563;
    }
  }

  .knowledge-name {
    display: inline-flex;
    align-items: center;
    line-height: 20px;
    color: #303133;
  }

  .knowledge-name__icon {
    margin-right: 8px;
    color: #f5a623;
    font-size: 14px;
    flex-shrink: 0;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 0;
  }

  &__action {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    background: #fff;
    cursor: pointer;
    transition: background-color 0.15s ease;
    outline: none;
    font-family: inherit;

    &[type='button'] {
      appearance: none;
    }

    &.is-edit {
      color: #606266;
      border: 1px solid #909399;
    }

    &.is-enable {
      color: #15803d;
      border: 1px solid #22c55e;
    }

    &.is-disable {
      color: #c2410c;
      border: 1px solid #f97316;
    }

    &.is-delete {
      color: #dc2626;
      border: 1px solid #ef4444;
    }

    &.is-bind {
      color: #4338ca;
      border: 1px solid #6366f1;
    }

    &:hover {
      background: #f9fafb;
    }
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

.cover-image {
  width: 64px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
}

.cover-image__placeholder {
  width: 64px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #909399;
  background: #f5f7fa;
}

.count-link {
  color: #409eff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &--muted {
    color: #909399;
  }

  &__content {
    display: inline-flex;
    align-items: center;
    line-height: 20px;
  }

  &__icon {
    margin-right: 4px;
    flex-shrink: 0;
  }
}

@media (max-width: 1200px) {
  .training-instruction-table {
    &__search-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .training-instruction-table {
    &__search-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<style lang="scss">
.training-instruction-table__search-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #606266;
    font-size: 13px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/pages/instruction/TrainingInstructionTable.vue